import { Component } from '@angular/core';
import { AnalyticsTrendWidgetComponent } from '@enginuity/analytics/organisms/analytics-trend-widget/analytics-trend-widget.component';
import { AnalyticsWidgetComponent } from '@enginuity/analytics/organisms/analytics-widget/analytics-widget.component';
import { FunnelChartComponent } from '@enginuity/analytics/organisms/funnel-chart/funnel-chart.component';
import { DashboardStore } from '../dashboard/dashboard.store';
import { DashboardOverviewStore } from './dashboard-overview.store';
import { DashboardCustomersStore } from '../dashboard-customers/dashboard-customers.store';
import { DashboardOrdersStore } from '../dashboard-orders/dashboard-orders.store';
import { GlobalLoaderWrapperComponent } from '@enginuity/analytics/organisms/global-loader-wrapper/global-loader-wrapper.component';

@Component({
  selector: 'app-dashboard-overview',
  imports: [
    AnalyticsWidgetComponent,
    AnalyticsTrendWidgetComponent,
    FunnelChartComponent,
    GlobalLoaderWrapperComponent,
  ],
  templateUrl: './dashboard-overview.component.html',
  styleUrl: './dashboard-overview.component.scss',
  providers: [DashboardOverviewStore, DashboardCustomersStore, DashboardOrdersStore],
})
export class DashboardOverviewComponent {
  // Get signals directly from the store
  protected rangeContext = this.dashboardStore.getRangeContextSignal();
  protected comparePeriod = this.dashboardStore.getComparePeriodSignal();

  protected customerAnalyticsResource =
    this.dashboardCustomersStore.createCustomerAnalyticsResource(this.rangeContext);

  protected orderAnalyticsResource = this.dashboardOrdersStore.createOrderAnalyticsResource(
    this.rangeContext
  );

  protected productAnalyticsResource = this.dashboardOverviewStore.createProductAnalyticsResource(
    this.rangeContext
  );

  protected checkoutStatsResource =
    this.dashboardOverviewStore.createCheckoutConversionStatsResource(this.rangeContext);

  constructor(
    private readonly dashboardStore: DashboardStore,
    private readonly dashboardOverviewStore: DashboardOverviewStore,
    private readonly dashboardCustomersStore: DashboardCustomersStore,
    private readonly dashboardOrdersStore: DashboardOrdersStore
  ) {}
}
